<template>
  <el-form ref="baseForm" label-width="120px" @submit.native.prevent>
    <h2>评委设置</h2>
    <el-divider></el-divider>
    <el-row>
      <el-form-item label="已添加评委" prop="cover">
        <div class="teacher" v-for="teacher in teachers" :key="teacher.id">
          <img class="avatar" src="@/assets/imgs/avatar.png" alt="" />
          <span class="teacher-name">{{ teacher.nickname }}</span>
          <span class="delete">
            <i class=" el-icon-close" @click="deleteTeacher(teacher.id)"></i>
          </span>
        </div>
        <el-autocomplete class="add" placeholder="请输入评委" v-model="input" :fetch-suggestions="querySearchAsync" @select="handleSelect" :trigger-on-focus="false"
          value-key="nickname">
          <template slot="append">添加</template>
        </el-autocomplete>
      </el-form-item>
    </el-row>

    <el-divider></el-divider>
    <el-form-item>
      <el-button type="primary" @click="handleUpdate()" :plain="true">保存</el-button>
      <el-button @click="next()">下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { updateTeachers, searchTeacher } from "@/api/classroom";
import { getToken } from "@/utils/auth";
import qs from "qs";
export default {
  methods: {
    next() {
      this.$router.push({
        name: "course-mark",
        query: { from: this.$route.query.from }
      });
    },
    submitForm(formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();
        } else {
          this.$message.error({
            message: "必填项不能为空"
          });
          return false;
        }
      });
    },
    querySearchAsync(queryString, cb) {
      var params = {
        q: queryString
      };
      searchTeacher(this.$route.params.classroomId, params).then(response => {

        cb(response.data);
      });
    },
    handleSelect(item) {
      this.teachers.push(item);
      this.input = '';
    },
    handleUpdate() {
      var teacherIds = [];
      for (let i = 0; i < this.teachers.length; i++) {
        teacherIds[i] = this.teachers[i].id
      }
      var params = {
        teacherIds: teacherIds,
        teachers: this.teachers
      };
      updateTeachers(this.$route.params.classroomId, qs.stringify(params)).then(
        response => {
          this.$message.success({
            message: "保存成功"
          });
          this.$emit("refresh");
          // this.$message({
          //   message: response.message,
          //   type: 'success'
          // });
        }
      );
    },
    deleteTeacher(id) {
      for (var i = 0; i < this.teachers.length; i++) {
        if (this.teachers[i].id == id) {
          this.teachers.splice(i, 1);
          break;
        }
      }
    },
    getValue(value) {
      this.baseForm.category_id = value;
      this.input = "";
    }
  },
  data() {
    return {
      classroom: null,
      teachers: [
        {
          id: 1,
          nickname: "admin",
          avatar: ""
        }
      ],
      teacherOption: [],
      input: "",
      creator: ""
    };
  },
  created() {
    this.classroom = { ...this.$attrs.classroom };
    // this.creator = this.classroom.creator.id;
    var arr = [];
    var obj = { ...this.$attrs.teachers };
    for (let i in obj) {
      let o = {};
      arr.push(obj[i]);
    }
    this.teachers = arr;
    // getCourse(this.$route.params.competitionId).then(response => {
    //   
    // });
  },
  mounted() { }
};
</script>

<style scoped>
/* .el-form {
    padding: 10px;
} */
.teacher {
  width: 550px;
  height: 62px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px 40px;
  box-sizing: border-box;
  margin-bottom: -1px;
  line-height: 40px;
  position: relative;
}
.avatar {
  display: inline-block;
  width: 40px !important;
  height: 40px !important;
  margin-right: 10px;
  border-radius: 4px;
}
.teacher-name {
  width: 160px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  box-sizing: border-box;
  /* line-height: 20px; */
  /* margin: 10px 0; */
}
.teacher-delete {
  display: inline-block;
}
.delete {
  position: absolute;
  top: 10px;
  right: 40px;
}
.add {
  margin-top: 25px;
  width: 550px;
}
.el-icon-close {
  cursor: pointer;
}
</style>
